import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber, TimePicker } from 'antd'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import Datetime from '../../../../components/user/from/Datetime/indexV2'
import InputUpload from '../../../../components/user/from/InputUpload'
import SelectStatus from '../../../../components/user/from/SelectStatus'
import { numberWithCommas } from '../../../../utils/number'
import { reDurationType } from '../../../../utils/leave'
import moment from 'moment'
import IframeFile from '../../../../components/user/IframeFile'
import ImageFileNewtab from '../../../../components/user/ImageFileNewtab'
import { changeFormatdate, changeFormatFulldate, changeFormatdateThai } from '../../../../utils/formatdate'
import { approveStatus, approveStatusNew } from '../../../../utils/leave'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import { profileObjectKey, employeeDetailObjectKey } from '../../../../utils/auth'
import { checkLinkURL } from '../../../../utils/auth'
import ComponetsRemarkText from '../Components/remarkText'
import TableCCEmail from '../../../../components/user/Leave/TableCCEmail'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;
const format = 'HH:mm';

const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
    { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

const newsDataProfileCheck = '';

class Withdraw extends Component {
	state = {
		loading:false,
		dataTalbeUploads: [
			// {
			// 	documentType: null,
            //     description:null,
			// 	attachFile:null,
            //     statusFile:false
			// },
		],
      columns: [
            {
                title: 'ประเภทเอกสาร',
                dataIndex: 'documentType',
				align:'center',
                vertical:'top',
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("documentType"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        message: 'กรุณากรอกเลือกไฟล์',
                                    }],
                                })(
                                    <Select 
                                        style={{ width: "100%" }}
                                        // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                                        disabled={true}
                                        showSearch
                                        placeholder="กรุณาเลือก"
                                        optionFilterProp="children"
                                    >
                                        {
                                            DOCUMENT_TYPE.map((valuesLabel, keys)=>{
                                                return <Option value={valuesLabel.value}>{ valuesLabel.label }</Option>
                                            })
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'รายละเอียดเพิ่มเติม',
                dataIndex: 'description',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("description"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        required: record.statusFile ? true : false, 
                                        message: 'กรุณาระบุ เลขที่ใบเสร็จ',
                                    }],
                                })(
                                    <Input 
                                        disabled={true}
                                        // defaultValue={item} 
                                        // onBlur={ (e) => this.onChangeValueForm(index, e, 'description') }
                                    />
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'เอกสารแนบ',
                dataIndex: '7',
                width:'200px',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
                           { this.inputFormUploads(index) }
                        </>
                    )
                }
            },
            // {
            //     title: 'จัดการ',
            //     dataIndex: '7',
            //     width:'20px',
            //     vertical:'top',
			// 	align:'center',
            //     render: (item, record, index) => {
            //         return this.showDetailBtnInput(record, index)
            //     }
            // },
      ],
      pageData: {
         offset: 0,
         limit: 10
      },
      pagination: {
         total: 10,
      },
      dataTalbeLength:1,
      preLoadOnsubmit: false,
      detailProfile:null,
      dropdownApproverMedical:[],
		dateTimeValue:moment(),
      leaveTypeId:null,
      leaveDay:null,
      showleaveDay:null,
      currentLeaveDay:null,
      remainLeaveDay:null,
      dropdownLeaveType:[],
      empCode:null,
      isCanLeaveOver:null,
      maxLeaveDay:null,
      minLeaveDay:null,
      reqAttachDay:null,
      reqAttachDayStatus:false,
      detailForm:null,
      loadingColumnsPeople:true,
      dataTalbePeople: [],
      columnsPeople: [
         {
               title: 'ลำดับ',
               dataIndex: 'docId',
               width:'8%',
         align:'center',
               render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
         },
         {
               title: 'วันที่ดำเนินรายการ',
               dataIndex: 'createdAt',
               width:'20%',
               align:'center',
               // render: (item, record, index) => <span>{moment(item).format('DD-MM-YYYY')}</span>
               render: (item, record, index) => <span>{ item ? changeFormatFulldate(item) : '-'}</span>
         },
      {
               title: 'ผู้ดำเนินรายการ',
               width:'20%',
               dataIndex: 'userAction',
               align:'center',
               render: (item, record, index) => <span>{ item }</span>
         },
         {
               title: 'สถานะ',
               dataIndex: 'approveStatus',
               width:'200px',
         align:'center',
               render: (item, record, index) => <span>{ approveStatus(item) }</span>
         },
         {
               title: 'หมายเหตุ',
               dataIndex: 'noteApprove',
               width:'200px',
            align:'center',
               render: (item, record, index) => <>
                  {
                     item ?
                           <span 
                              onClick={()=>{this.showModalNode(item)}} 
                              style={{ cursor:"pointer" }}
                              className="btn-show-fileuploads"
                           > 
                              อ่านหมายเหตุ
                           </span>
                     : '-'
                  }
                  
               </>
         },
      ],
      dataTalbeAttendance: [
			{
				dateFirstLeave: moment(),
                empCodeLeave:5594825,
                timeFirst: moment(),
				timeLast: moment().add(5, 'hours'),
                statusFile:false
			},
            {
				dateFirstLeave: moment().add(1, 'days'),
                empCodeLeave:5594825,
                timeFirst: moment().add(2, 'hours'),
				timeLast: moment().add(7, 'hours'),
                statusFile:false
			},
            {
				dateFirstLeave: moment().add(2, 'days'),
                empCodeLeave:5594825,
                timeFirst: moment().add(-7, 'hours'),
				timeLast: moment().add(6, 'hours'),
                statusFile:false
			},
		],
      columnsAttendance: [
         {
               title: 'วันที่ขอลา',
               dataIndex: 'dateFirstLeave',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { changeFormatdate(item) }
                           </label>
                           {/* <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("documentType"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       required: record.description ? true : false,
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <Input 
                                       disabled={true}
                                 />
                              )}
                           </Form.Item> */}
                     </>
                  )
               }
         },
         {
               title: 'รหัสกะงาน',
               dataIndex: 'empCodeLeave',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { item }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาเริ่มต้น',
               dataIndex: 'timeFirst',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { moment(item).format('HH:mm') }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาสิ้นสุด',
               dataIndex: 'timeLast',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { moment(item).format('HH:mm') }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาเริ่มต้น',
               dataIndex: '655',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("655"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <TimePicker 
                                       format={format} 
                                       placeholder="" 
                                       // disabledHours={() => this.getDisabledHours(record)}
                                       // disabledMinutes={(e) => this.getDisabledMinutes(e, record)}
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'เวลาสิ้นสุด',
               dataIndex: '444',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("444"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <TimePicker format={format} placeholder="" />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'จำนวน ซม.',
               dataIndex: '123',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("123"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาเลือกประเภทเอกสาร',
                                 }],
                              })(
                                 <Input 
                                       disabled={true}
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
      ],
      ModalConfirmFormTitle:null,
      ModalConfirmFormSubTitle:null,
      ModalConfirmFormShowModal:false,
      ModalConfirmFormBtnOk:null,
      ModalConfirmFormBtnCancel:null,
      ModalConfirmFormValue:null,
      ModalConfirmFormStatus:null,
      ModalConfirmFormMessage:null,
      ModalFormTextArea:false,
      ModalFormTextAreaRequie: false,
      loadingFullpage: false,
      manualLeave: [],
      detailStatus: null
	}

    dateFormatNumber = (values) =>{
        let valueReturn = this.props.form.getFieldValue(values)
        return changeFormatdate(moment(valueReturn))
    }

    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };







    fetchListLeaveDocumentApprover = async () =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchListLeaveDocumentApprover,
        })

        // console.log('data.fetchListLeaveDocumentApprover',data.fetchListLeaveDocumentApprover)

        if(data.fetchListLeaveDocumentApprover){
            await this.setState({
                dropdownApproverMedical: data.fetchListLeaveDocumentApprover
            })
        }
    }

    employeeDetailProfileForLeave = async (empCode) => {
      const { client, location, match } = this.props
      // const { empCode } = this.state
      const { data, errors } = await client.query({
          query: Queries.employeeDetailProfileForLeave,
          variables:{
              empCode,
          }
      })

      if(data.employeeDetailProfileForLeave){
          await this.setState({
              detailProfile: data.employeeDetailProfileForLeave,
          })

         //  await this.dropdownLeaveType();
      }else{
          await this.setState({
              detailProfile:null,
              loadingFullpage:false
          })
      }
  }

    showDetailBtnInput = (record, arrayId) =>{
        const { dataTalbeUploads } = this.state
        return(
            <>
                {
                    dataTalbeUploads.length > 1 ? 
                            <Avatar 
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1 bg-red"  
                                // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                style={{ cursor: 'pointer', background:"red" }}
                            />
                    : 
                        <Avatar 
                            shape="square"  
                            icon={<Icon type="delete" />} 
                            className="mr-1 mb-1 bg-red"  
                            // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                            style={{ cursor: 'not-allowed' }}
                            disabled={true}
                        />
                }
            </>
        )
    }

    showDataInputUploads = async () =>{
        const { dataTalbeUploads, reqAttachDayStatus } = this.state
        const rows = {
            documentType: null,
            statusFile: false,
            description: null,
            attachFile: null,
        }
        await this.setState(prevState => ({
            dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        }), async () => {
            let lengthData = dataTalbeUploads.length+1;
            await this.setState({
                dataTalbeLength: lengthData
            })
        })
    }



    modalShowFile = async (dataFile, title) =>{
        Modal.info({
            className:"modalFickIcons",
            title: "ไฟล์อัปโหลดเอกสาร",
            width:"800px",
            content: (
              <div >
                  {
                    dataFile.fileType == 'application/pdf' ?
                        <IframeFile typeFile={dataFile.fileType}  file={dataFile.attachFile} formUpload={true}/>
                    :
                        <ImageFileNewtab typeFile={dataFile.fileType}  file={dataFile.attachFile} formUpload={true}/>
                  }
              </div>
            ),
            okText: 'ปิด',
            onOk() {},
            // closable:({disabled:false})
        });
    }

    inputFormUploads = (arrayId) =>{
        const { dataTalbeUploads } = this.state
        let fileName = dataTalbeUploads[arrayId].attachFile ? dataTalbeUploads[arrayId].attachFile.name : ""
        return(
            <>
                {
                    dataTalbeUploads[arrayId].attachFile ? 
                        <>
                            <Text 
                                onClick={ () => { this.modalShowFile(dataTalbeUploads[arrayId], 'เอกสารแนบ') }} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            >
                                ดูไฟล์อัปโหลด
                            </Text>
                            <br></br>
                        </>
                    : '-'
                }
            </>
        )
    }

    sendToCreateLeave = async (values) => {
        const { form, client, match } = this.props
        const {  detailForm, detailStatus } = this.state

         await this.setState({
            loadingFullpage: true
         })

         await this.hideModalConfirm()

         try {
            let approversDropDown = []
            let attachFiles = []
            let checkModal = false

            if(checkModal){
               Modal.error({
                  title: 'กรุณาอัปโหลดรูปภาพหรือไฟล์',
                  className:'custom-modal-error',
                  okText: 'ตกลง',
            });
               await this.setState({
                  preLoadOnsubmit: false,
                  loadingFullpage: false
               })
            }else{
               const { data, errors } = await client.mutate({
                  mutation: Mutations.updateLeaveDocument,
                  variables: {
                     docId: match.url.split('/')[4],
                     durationType: detailForm.durationType,
                     //approveStatus: detailStatus.toUpperCase() == "APPROVE" ? 'PC' : 'C',
                     approveStatus: 'PC',
                     leaveStartDate: detailForm.leaveStartDate,
                     leaveEndDate: detailForm.leaveEndDate,
                     noteApprove: values.ModalNoteApprove,
                     autoApprove: false
                  }
               })

               if(data){

                  //ส่วนของการกดขออนุมัติการขอลาพี่โบ้สจะให้ใช่ message ว่าอะไรครับ
                     message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                     setTimeout(() => {
                        window.location.href = '/Leave/search/'
                     }, 600);
                     await this.setState({
                        loadingFullpage: false
                     })
               }else{
                  await this.setState({
                     preLoadOnsubmit: false,
                     loadingFullpage: false
                  })
               }
            }
         }catch (error) {
            await this.setState({
               preLoadOnsubmit: false,
               loadingFullpage: false
            })
            console.log('error',error)
         }
    }
    
    
    handleSubmit = async (e) => {
         const { form, client, match } = this.props
         const { 
            detailForm,
            detailStatus
         } = this.state
         
        e.preventDefault()
        form.validateFields(async (err, values) => {
            if (!err) {
               let ModalFormTextAreaRequie = false
               let ModalFormTextArea = false

               await this.setState({
                  ModalConfirmFormTitle:"ท่านยกเลิกการลา ด้วยสาเหตุใด?",
                  ModalConfirmFormShowModal:true,
                  ModalConfirmFormBtnOk:"ตกลง",
                  ModalConfirmFormBtnCancel:'ยกเลิก',
                  ModalConfirmFormValue: values,
                  ModalConfirmFormStatus: 'PC',
                  // ModalConfirmFormMessage: messageShow,
                  ModalFormTextArea,
                  ModalFormTextAreaRequie
            })
      }else{
            this.setState({
               preLoadOnsubmit: false
            })
      }
   })
        
    }

    handleSubmitCancel = async (e) => {
        window.location.href = '/hospital/search/'
        // this.sendToCreateLeave(e, 'DRAFT')
    }

    fetchLeaveDocumentDetail = async()=>{
        const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

        await this.setState({
            preLoadSubmit:true,
            loading:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDocumentDetail,
            variables:{
                docId: match.url.split('/')[4]
                // leaveStartDate:disabledDateStart,
                // leaveEndDate:endStartValues,
                // leaveTypeId:"1",
            }
        })


        if(data.fetchLeaveDocumentDetail){
            await this.setState({
                dataTalbeUploads: data.fetchLeaveDocumentDetail.attachFiles,
                detailForm: data.fetchLeaveDocumentDetail,
                leaveTypeId: data.fetchLeaveDocumentDetail.leaveTypeId,
                leaveTypeCategory: data.fetchLeaveDocumentDetail.durationType,
            })
        }else{
            await this.setState({
                loading:false,
                preLoadSubmit:false,
            })
        }
    }

    fetchLeaveDocumentDetailStatus = async() => {
      const { client,location ,match } = this.props
      const { offset ,limit, disabledDateStart, endStartValues } = this.state

      await this.setState({
          preLoadSubmit:true,
          loading:true
      })

      const { data, errors } = await client.query({
          query: Queries.fetchLeaveDocumentDetailStatus,
          variables:{
              docId: match.url.split('/')[4]
          }
      })

      console.log('data.fetchLeaveDocumentDetailStatus',data.fetchLeaveDocumentDetailStatus)

      if(data.fetchLeaveDocumentDetailStatus){
          await this.setState({
              detailStatus: data.fetchLeaveDocumentDetailStatus.status,
          })
      }else{
          await this.setState({
              loading:false,
              preLoadSubmit:false,
          })
      }
  }
    
    fetchLeaveDocumentHistory = async()=>{
        const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

        await this.setState({
            loadingColumnsPeople:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDocumentHistory,
            variables:{
                docId: match.url.split('/')[4]
            }
        })

        console.log('data.fetchLeaveDocumentHistory',data.fetchLeaveDocumentHistory)
        if(data.fetchLeaveDocumentHistory){
            await this.setState({
                dataTalbePeople: data.fetchLeaveDocumentHistory,
                loadingColumnsPeople:false
            })
        }else{
            await this.setState({
                loading:false,
                loadingColumnsPeople:false,
            })
        }
    }

    hideModalConfirm = async () =>{
      await this.setState({
          ModalConfirmFormTitle:null,
          ModalConfirmFormSubTitle:null,
          ModalConfirmFormShowModal:false,
          ModalConfirmFormBtnOk:null,
          ModalConfirmFormBtnCancel:null,
          ModalConfirmFormValue:null,
          ModalConfirmFormStatus:null,
         ModalConfirmFormMessage:null
      })
   }

   checkShowBtnSubmit = (checkRow = false) =>{
      const { detailForm, detailStatus } = this.state
      let currentDate = moment().format('YYYY-MM-DD')
      let disAllowCancle = detailForm ? moment(currentDate).isAfter(moment(detailForm.leaveStartDate).format('YYYY-MM-DD')) : false
      if(detailStatus == "PENDING_CANCEL"){
         return false
      }
      else if(detailStatus == "CANCEL"){
         return false
      }else if(detailStatus == "DRAF"){
         return true
      }else if(detailStatus == 'PENDING' && detailForm.isCancelByReq && !disAllowCancle){
         return true
      }else if(detailStatus == 'APPROVE' && !disAllowCancle){
         return true
      }else if(checkRow && detailStatus == "DRAF"){
         return true
      }else{
         return false
      }
   }

   fetchMasterConfigTypeLeave = async () =>{
      const { client, location, match } = this.props

      const { data, errors } = await client.query({
         query: Queries.fetchMasterConfigTypeLeave,
      })
      if(data.fetchMasterConfigTypeLeave){
         let manualLeave = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "ManualApprover")
         let remarkText = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "Remark")
         await this.setState({
            remarkText: remarkText ? remarkText[0].configValue1 : null,
            manualLeave
         })
      }
   }

   fetchProfileForLeave = async () => {
      const { client, location, match } = this.props
      const { posId } = this.state
      const { data, errors } = await client.query({
          query: Queries.fetchProfileForLeave,
      })
      console.log('data.fetchProfile,', data.fetchProfileForLeave,)
      await this.setState({
         detailProfile: data.fetchProfileForLeave,
      })

   }

	async componentDidMount(){
      await Promise.all(
         [
            this.fetchProfileForLeave(),
            this.fetchLeaveDocumentDetail(),
            this.fetchLeaveDocumentDetailStatus(),
            this.fetchLeaveDocumentHistory(),
         ]
      )

      
        // await this.fetchListLeaveDocumentApprover()
        // await this.fetchMedicalExpensesLicensee()
        // await this.dropdownMedicalExpensesLicensee()
        // await this.dropdownListHospital()
        // await this.dropdownListSickness()
    }

	render() {
		const { match } = this.props
        const { getFieldDecorator } = this.props.form
        const { 
            columns, 
            preLoadOnsubmit, 
            dataTalbeUploads, 
            dropdownApproverMedical,
            detailProfile,
            showleaveDay,
            currentLeaveDay,
            remainLeaveDay,
            dropdownLeaveType,
            detailForm,
            showModalNote,
            noteModal,
            titleModal,
            columnsPeople,
            dataTalbePeople,
            loadingColumnsPeople,
            dataTalbeAttendance,
            columnsAttendance,
            leaveTypeCategory,
            ModalConfirmFormTitle,
            ModalConfirmFormSubTitle,
            ModalConfirmFormShowModal,
            ModalConfirmFormBtnOk,
            ModalConfirmFormBtnCancel,
            ModalConfirmFormValue,
            ModalFormTextArea,           
            ModalFormTextAreaRequie,
            loadingFullpage,
            modalGuideLineTax,
            manualLeave,
            remarkText,
            leaveDayAllData,
            historyYear,
            detailStatus
        } = this.state

		return (
            <Container match={match}>
                <div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การลา / ดูเอกสารการลา </span>
                    {/* </Breadcrumb.Item> */}
                </div>
                <Modal
                    visible={showModalNote}
                    title={titleModal}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <p>{noteModal}</p>
                </Modal>

                {
                    detailProfile && detailForm ?
                        <Spin spinning={loadingFullpage} delay={500}>
                           <ModalConfirmForm 
                              title={ModalConfirmFormTitle} 
                              subtitle={ModalConfirmFormSubTitle}
                              showModal={ModalConfirmFormShowModal} 
                              btnOk={ModalConfirmFormBtnOk} 
                              btnCancel={ModalConfirmFormBtnCancel}  
                              submitToSend={ this.sendToCreateLeave }
                              hideModal={ this.hideModalConfirm }
                              valueConfirm = { ModalConfirmFormValue }
                              ModalFormTextArea = { true }
                              ModalFormTextAreaRequie = { true }
                              // ModalFormTextArea = {ModalFormTextArea}
                              // ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
                           />
                           <div className="card-container h-100" id="page-profile">
                              <Form ref={this.formRef}>
                                 <div className="px-5 pt-1 pb-4 card-bg-green">
                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                       <Col xs={24} md={24} className="pt-2">
                                          <strong className="color-red">
                                                ข้อมูลบุคลากร
                                          </strong>
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.empName} required={false} name={"name"} label="ชื่อบุคลากร" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.division ? detailProfile.division : '-'} required={false} name={"diviName"} label="ฝ่าย" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.department ? detailProfile.department : '-'} required={false} name={"deptName"} label="หน่วยงาน" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.subDeptName ? detailProfile.subDeptName : '-'} required={false} name={"subDeptName"} label="งาน" mode={"text"} />
                                       </Col>
                                       {/* <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput hidden disabled={true} value={detailProfile.childSubDeptName ? detailProfile.childSubDeptName : '-'} required={false} name={"childSubDeptName"} label="lv5" mode={"text"} />
                                       </Col> */}

                                    </Row>

                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                       <Col xs={24} md={12} className="pt-2">
                                          <strong className="color-red">
                                             ข้อมูลการลา
                                          </strong>
                                       </Col>
                                       <Col xs={24} md={12} className="pt-2 text-right">
                                          {
                                             manualLeave.length > 0 ?
                                                <>
                                                   <div align="right" className="div-guild-line">
                                                         <p  style={{width:"auto", cursor:"pointer", textDecoration:"underline", color:"blue"}} onClick={ async () => this.setState({modalGuideLineTax:true}) }>
                                                            คู่มือการใช้งาน 
                                                         </p>
                                                      </div>

                                                      <Modal
                                                         destroyOnClose={true}
                                                         visible={modalGuideLineTax}
                                                         maskClosable={false}
                                                         title={"คู่มือการใช้งาน"}
                                                         onCancel={ async () => await this.setState({modalGuideLineTax:false})}
                                                         width={600}
                                                         okText={ "" }
                                                         cancelText={ "ปิด" }
                                                         footer={null}
                                                      >
                                                         <Row gutter={16} type="flex" justify="left" align="top" >
                                                            <Col xs={24} md={24} >
                                                               <ol className="pl-3">
                                                               {
                                                                   manualLeave.map((values, keys)=>{
                                                                     if(values.typeValue == 'file'){
                                                                        return <li className="mb-2">
                                                                                 <a style={{ textDecoration:"underline" }} href={ checkLinkURL()+values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                                              </li>
                                                                     }else if(values.typeValue == 'link'){
                                                                        return <li className="mb-2">
                                                                                 <a style={{ textDecoration:"underline" }} href={ values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                                              </li>
                                                                     }
                                                                  })
                                                               }
                                                               </ol>
                                                            </Col>

                                                            <Col xs={24} md={24} align="right">
                                                               <Button 
                                                                  type="primary " 
                                                                  className="mt-1 color-white"
                                                                  htmlType="submit"
                                                                  onClick={ async () => await this.setState({modalGuideLineTax:false}) }
                                                               >
                                                                  ปิด
                                                               </Button>
                                                            </Col>
                                                         </Row>
                                                        
                                                      </Modal>
                                                </>
                                             :
                                             ''
                                          }
                                       </Col>
                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={ detailForm.docNo ? detailForm.docNo : '-' } required={false} name={"docId"} label="เลขที่เอกสาร" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <FromInput 
                                             disabled={true} 
                                             value={ 
                                                      detailStatus ? 
                                                      approveStatusNew(detailStatus) : 
                                                      '-' 
                                                   } 
                                             required={false} 
                                             name={"status"} 
                                             label="สถานะเอกสาร" 
                                             mode={"text"} 
                                          />
                                       </Col>

                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <Form.Item label={'วันที่ยื่นเรื่อง'} className="mb-0">
                                                { getFieldDecorator('documentDate', {
                                                   initialValue: moment(detailForm.documentDate),
                                                   rules:  [{ 
                                                      required:true, 
                                                      message: 'กรุณากรอกหรือเลือก วันที่ยื่นเรื่อง',
                                                   }],
                                                })(
                                                   <DatePicker 
                                                      format={this.dateFormatNumber("documentDate")} 
                                                      placeholder="" 
                                                      style={{ width:"100%" }} 
                                                      disabled={true}
                                                   />
                                                )}
                                          </Form.Item>
                                       </Col>

                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={ detailForm.leaveTypeName  ? detailForm.leaveTypeName  : '-'} required={false} name={"leaveTypeName"} label="ประเภทการลา" mode={"text"} />
                                       </Col>

                                       <Col xs={ 24 } md={12}>
                                          <Form.Item label="วันที่เริ่มลา" className="mb-0">
                                                { getFieldDecorator('leaveStartDate', {
                                                   initialValue: moment(detailForm.leaveStartDate),
                                                   rules:  [{ 
                                                      required: true, 
                                                      message: 'กรุณากรอกหรือเลือก วันที่เริ่มลา',
                                                   }],
                                                })(
                                                   <DatePicker 
                                                      format={this.dateFormatNumber("leaveStartDate")} 
                                                      className="w-100"  
                                                      placeholder="เลือกวันที่"
                                                      disabled={true} 
                                                   />
                                                )}
                                          </Form.Item>
                                       </Col>
                                       
                                       <Col xs={ 24 } md={12}>
                                          <Form.Item label="วันที่สิ้นสุดการลา" className="mb-0">
                                                { getFieldDecorator('leaveEndDate', {
                                                   initialValue: moment(detailForm.leaveEndDate),
                                                   rules:  [{ 
                                                      required:true,
                                                      message: 'กรุณากรอกหรือเลือก วันที่สิ้นสุดการลา',
                                                   }],
                                                })(
                                                   <DatePicker 
                                                      format={this.dateFormatNumber("leaveEndDate")} 
                                                      disabled={ true }
                                                      className="w-100" 
                                                      // defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
                                                      placeholder="เลือกวันที่"
                                                   />
                                                )}
                                          </Form.Item>
                                       </Col>

                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <FromInput
                                                disabled={true} 
                                                value={ reDurationType(detailForm.durationType) } 
                                                required={false} 
                                                name={"name"} 
                                                label="ช่วงเวลาการลา" 
                                                mode={"text"} 
                                          />
                                       </Col>

                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <div hidden={leaveTypeCategory == 'Custom' ? true : false}>
                                             <Form.Item label={"จำนวนวันลา"} className="mb-0">
                                                   { this.props.form.getFieldDecorator("leaveDay", {
                                                      initialValue: detailForm.leaveDay,
                                                      rules:  [{ 
                                                         required: true, 
                                                         message: 'กรุณากรอกเลือกจำนวนวันลา',
                                                      }],
                                                   })(
                                                      <Input 
                                                         className='block-news mb-0' 
                                                         disabled={true}
                                                         hidden={leaveTypeCategory == 'Custom' ? true : false}
                                                      />
                                                   )}
                                             </Form.Item>
                                          </div>
                                       </Col>

                                          {
                                                leaveTypeCategory == 'Custom' &&
                                                <>
                                                   <Col xs={24} md={12}>
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="shiftCode" values={detailForm.shiftCode} label="รหัสกะงาน" /> */}
                                                      <FromInput disabled={true} value={ detailForm.shiftCode } required={false} name={"leaveTypeName"} label="รหัสกะงาน" mode={"text"} />
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="shiftTime" values={detailForm.shiftTime} label="เวลาทำงานของกะงาน" /> */}
                                                      <FromInput disabled={true} value={ detailForm.shiftTime } required={false} name={"shiftTime"} label="เวลาทำงานของกะงาน" mode={"text"} />
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      <FromInput disabled={true} value={ detailForm.leaveStartTime } required={false} name={"leaveStartTime"} label="เวลาเริ่มต้น" mode={"text"} />
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="leaveStartTime" values={detailForm.leaveStartTime} label="เวลาเริ่มต้น" /> */}
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      <FromInput disabled={true} value={ detailForm.leaveEndTime } required={false} name={"leaveEndTime"} label="เวลาสิ้นสุด" mode={"text"} />
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="leaveEndTime" values={detailForm.leaveEndTime} label="เวลาสิ้นสุด" /> */}
                                                   </Col>

                                                   <Col xs={24} md={12}>
                                                      <FromInput disabled={true} value={ detailForm.leaveHour ? detailForm.leaveHour.label : '' } required={false} name={"leaveHour"} label="จำนวนชั่วโมงการลา" mode={"text"} />
                                                      {/* <FromInput disabled={true} mode={"title"} required={false} name="leaveHour" values={detailForm.leaveHour ? detailForm.leaveHour.value : ''} label="จำนวนชั่วโมงการลา" /> */}
                                                   </Col>
                                                </>
                                          }

                                       <Col xs={24} md={24}  className="pt-2">
                                          <Form.Item label={"หมายเหตุการลา"}>
                                                { getFieldDecorator("description", {
                                                   initialValue: detailForm.description,
                                                   rules:  [{ 
                                                      // required: true, 
                                                      message: 'กรุณาระบุ หมายเหตุการลา',
                                                   }],
                                                })(
                                                   <TextArea rows={3} className='block-news' disabled={true} />
                                                )}
                                          </Form.Item>
                                       </Col>

                                       <Col xs={24} md={24}  className="" >
                                          <ComponetsRemarkText remarkText={remarkText}/>
                                       </Col>
                                    </Row>

                                    {/* <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white">
                                       <Col xs={24} md={24} >
                                          <TableCCEmail 
                                             getFieldDecorator= {getFieldDecorator}
                                             rawDataDetail={detailForm.notiCC}
                                             detailProfile = {detailProfile}
                                             isViewOnly = {true}
                                          />
                                       </Col>
                                    </Row> */}

                                    {/* {  
                                       leaveDayAllData.length  > 0 &&
                                          <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white">
                                             <Col xs={24} md={24} className="mb-5">
                                                <strong className="color-red">
                                                   ประวัติการลาประจำปี {historyYear}
                                                </strong>
                                             </Col>
                                             <Col xs={24} md={24}>
                                                <Row gutter={16} type="flex"  align="top" className="box-show-number px-4 mb-4">
                                                      <Col xs={24} md={9} className="" align={"center"}>
                                                         <strong className="">
                                                            ประเภทการลา
                                                         </strong>
                                                      </Col>
                                                      <Col xs={24} md={5} className="" align={"right"}>
                                                         <strong className="">
                                                            สิทธิการลา
                                                         </strong>
                                                      </Col>
                                                       <Col xs={24} md={5} className="" align={"right"}>
                                                         <strong className="color-orange">
                                                            วันลาคงเหลือ
                                                         </strong>
                                                      </Col>
                                                      <Col xs={24} md={5} className="" align={"right"}>
                                                         <strong className="color-green">
                                                            วันลาที่ใช้ไปแล้ว
                                                         </strong>
                                                      </Col>
                                                </Row>
                                                {
                                                   leaveDayAllData.map((values, keys)=>{
                                                      return   values.currentLeaveDay ?
                                                                  <Row type="flex" gutter={16}  align="top" className="box-show-number  px-4 ">
                                                                     <Col xs={24} md={8} className="" align={"left"}>
                                                                           <p className="mb-1">
                                                                              {values.leaveTypeName}<br></br>
                                                                           </p>
                                                                     </Col>
                                                                     
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={ values.leaveDay || values.leaveDay == 0 ? 'numberLeav' : '' }>
                                                                              { values.isShowRemaVtrc ? values.leaveDay || values.leaveDay == 0 ? values.leaveDay : '-' : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={values.remainLeaveDay || values.remainLeaveDay == 0 ? 'numberLeav color-orange' : 'color-orange'}>
                                                                              { values.isShowRemaVtrc ? values.remainLeaveDay || values.remainLeaveDay == 0 ? this.checkLeaveDayAllValue(values.remainLeaveDay.toString()) : '-' : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={values.currentLeaveDay || values.currentLeaveDay == 0 ? 'numberLeav color-green' : 'color-green'}>
                                                                              { values.currentLeaveDay || values.currentLeaveDay == 0 ? this.checkLeaveDayAllValue(values.currentLeaveDay.toString()) : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     
                                                                     <Col md={24}>
                                                                        <hr></hr>
                                                                     </Col>
                                                                  </Row>
                                                               :
                                                               ''
                                                   })
                                                }
                                             </Col>
                                          </Row>
                                    }
                                     */}
                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                       <Col xs={24} md={24} className="pt-2 mb-3">
                                          <strong className="color-red">
                                                เอกสารแนบ
                                          </strong>
                                       </Col>
                                       
                                       <Col xs={24} md={24} align={"right"}>
                                          <Table
                                                columns={columns}
                                                dataSource={dataTalbeUploads}
                                                pagination={false}
                                                className="mb-3"
                                                bordered
                                                // rowCount={dataTalbeUploads.length}
                                                // pagination={{ pageSize: dataTalbeUploads.length }}
                                                locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                          />
                                       </Col>
                                    </Row>

                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mt-4" >
                                       <Col xs={24} md={24} className="pt-2 mb-4">
                                          <strong className="color-red">
                                                ประวัติการลาที่อนุมัติ
                                          </strong>
                                          <Table
                                                columns={columnsPeople}
                                                dataSource={dataTalbePeople}
                                                pagination={false}
                                                loading={loadingColumnsPeople}
                                                className="mt-4"
                                                bordered
                                                rowCount={dataTalbePeople.length}
                                          />
                                       </Col>
                                    </Row>
                                 
                                    <Row gutter={16} type="flex" justify="left" align="top">
                                       <Col xs={24} md={24} align={"center"}>
                                          <Link
                                             to={{
                                                pathname: '/Leave/search/'
                                             }}
                                          >
                                             <Button type="primary" className="mx-2 btn-white-red" disabled={ preLoadOnsubmit }>
                                                ย้อนกลับ
                                             </Button>
                                          </Link>

                                          {
                                             this.checkShowBtnSubmit() &&
                                             (detailForm.approveStatus !== "CANCEL" && !detailProfile.isBC) ?
                                                   <Button 
                                                      type="primary" 
                                                      className="mr-3 btn-white-red" 
                                                      htmlType="submit" 
                                                      onClick={this.handleSubmit} disabled={ preLoadOnsubmit }
                                                   >
                                                      ยกเลิกการลา
                                                   </Button>
                                                : ''   
                                          }
                                       </Col>
                                    </Row>
                                 </div>
                              </Form>
                           </div>
                        </Spin>
                    :
                        <Row>
                            <Col align="center" className="mt-5">
                                <Spin size="large" />
                            </Col>
                        </Row>
                }
                
            </Container>
		)
	}
}

Withdraw.defaultProps = {
	autoFocus: false
}

Withdraw.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedWithdraw = Form.create()(Withdraw)

export default withApollo(WrappedWithdraw)